import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from '../contexts/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const url = new URL(window.location.href);
        const oauthError = url.searchParams.get('error_description') || url.searchParams.get('error');
        if (oauthError) {
          console.error('OAuth error:', oauthError);
          if (!cancelled) navigate('/', { replace: true });
          return;
        }

        if (url.searchParams.get('code')) {
          const { error } = await supabase.auth.exchangeCodeForSession(window.location.href);
          if (error) {
            console.error('Session exchange failed:', error);
            if (!cancelled) navigate('/', { replace: true });
            return;
          }
        }

        let session = null;
        for (let i = 0; i < 8; i += 1) {
          if (cancelled) return;
          const { data } = await supabase.auth.getSession();
          session = data.session;
          if (session) break;
          await new Promise((r) => setTimeout(r, 150));
        }

        if (cancelled) return;
        if (session) {
          // Hydrate the profile in AuthContext before navigating, otherwise
          // ProtectedRoute will see user=null and bounce back to /login.
          await checkAuth();
          if (cancelled) return;
          navigate('/dashboard', { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      } catch (e) {
        console.error(e);
        if (!cancelled) navigate('/', { replace: true });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center gradient-aurora">
      <div className="text-center px-6">
        <div className="mx-auto mb-5 h-12 w-12 rounded-2xl gradient-primary flex items-center justify-center shadow-glow">
          <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
        </div>
        <div className="font-display text-2xl font-bold text-foreground">Signing you in…</div>
        <p className="text-muted-foreground mt-2 text-sm">Hang tight while we complete authentication.</p>
      </div>
    </div>
  );
}
